<template>
  <div id="modalRefund" class="modal fade">
    <div class="modal-dialog modal-dialog-vertical-center modal-md" role="document">
      <div class="modal-content bd-0 tx-14">
         <modal-loading :show="loading"></modal-loading> 
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("mall.退款处理")}}</h6>
          <button type="button" data-dismiss="modal" aria-label="Close" class="close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
        	<div class="form-group row align-items-center pd-x-10 mg-x-0">
           		<label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right pd-0">{{$t("mall.订单号：")}}</label> 
        		<div class="col-md-6 col-sm-12 pd-l-0 tx-gray-900">
        			{{orderDetail.orderCode}}
    			</div>
           	</div>
           	<div class="form-group row align-items-center pd-x-10 mg-x-0">
           		<label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right pd-0">{{$t("mall.订单总金额：")}}</label> 
        		<div class="col-md-3 col-sm-12 pd-l-0 tx-gray-900">
        			￥  {{orderDetail.payRecord ? Number(orderDetail.payRecord.amount).toFixed(2) : '---'}}
    			</div>
    			<label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right pd-0">{{$t("mall.订单已退款金额：")}}</label> 
        		<div class="col-md-3 col-sm-12 pd-l-0 tx-gray-900">
        			￥  {{orderDetail.payRecord ? Number(orderDetail.payRecord.refundAmount).toFixed(2) : '---'}}
    			</div>
           	</div>
           	<div class="form-group row align-items-center pd-x-10 mg-x-0">
           		<label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right pd-0">{{$t("mall.本次退款金额：")}}</label> 
        		<div class="col-md-3 col-sm-12 pd-l-0 tx-gray-900">
        			<input v-model="refundMoney" type="text" :placeholder="$t('mall.退款金额')" name="salePrice" class="wd-100 form-control form-control-sm">
    			</div>
    			<div class="col-md-6 col-sm-12 pd-l-0 tx-gray-900">
        			({{$t("mall.剩余可退款金额  ￥ ")}} {{Number(surplusMoney).toFixed(2)}})
    			</div>
           	</div>
           	<div class="form-group row align-items-center pd-x-10 mg-x-0">
           		<label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right pd-0">{{$t("mall.管理员备注：")}}</label> 
        		<div class="col-md-9 col-sm-12 pd-l-0 tx-gray-900">
        			<textarea v-model="refundRemark" rows="3" name="remark" class="form-control form-control-sm tx-13" :placeholder="$t('mall.管理员备注')"></textarea>
    			</div>
           	</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" @click="save">{{$t("mall.确定")}}</button>
          <button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("mall.取消")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open","info"],
  data() {
    return {
    	loading:false,
    	orderDetail:"",
    	refundMoney:"",
    	refundRemark:"",
    	surplusMoney:0,
    }
  },
  created() {
  },
  updated() {
  },
  watch:{
  	open: function(){
  		this.loading = false;
  		
  		this.refundRemark = "";
  		this.orderDetail = this.info;
  		this.surplusMoney = 0;
  		if(this.orderDetail.payRecord){
  			this.surplusMoney = Number(this.orderDetail.payRecord.amount) - Number(this.orderDetail.payRecord.refundAmount);
  			
  		}
			this.refundMoney = parseFloat(this.orderDetail.amount).toFixed(2);
//		this.getRefundOrderDetail();
  	},
  },
  methods: {
  	getRefundOrderDetail(){
  		this.loading = true;
  		$.api_call("api.AccountDetail.getRefundOrderDetail", {
  			accountId: this.info.id
  		}, r => {
  			this.loading = false;
	        if (r.ErrorCode == "9999") {
	        	this.orderDetail = r.Data.Results;
	        } else {
	          	ShowTip(r.Message, "danger");
	        }
  		});
  	},
  	save(){
  		this.loading = true;
  		$.api_call("api.AccountDetail.refundMoneyBySupplier", {
  			accountId: this.info.id,
  			refundMoney: this.refundMoney,
  			distributorRemark: this.refundRemark,
  		}, r => {
  			this.loading = false;
	        if (r.ErrorCode == "9999") {
	        	$("#modalRefund").modal("hide");
	          	ShowTip(this.$t('mall.退款成功'),"success");
	          	this.$parent.getList();
	        } else {
	          	ShowTip(r.Message, "danger");
	        }
  		});
  	}
  }
};
</script>
